document.documentElement.classList.remove('no-js');

const header = document.querySelector('[data-crepulo-header]');
const menu = document.querySelector('[data-mobile-menu]');
const openMenu = document.querySelector('[data-open-menu]');
const closeMenu = document.querySelector('[data-close-menu]');

if (header) {
  const setHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
  setHeader();
  window.addEventListener('scroll', setHeader, { passive: true });
}

if (menu && openMenu && closeMenu) {
  openMenu.addEventListener('click', () => {
    menu.classList.add('is-open');
    openMenu.setAttribute('aria-expanded', 'true');
  });

  closeMenu.addEventListener('click', () => {
    menu.classList.remove('is-open');
    openMenu.setAttribute('aria-expanded', 'false');
  });
}

// Predictive search: results drop under the field as you type, no page load.
// Falls back to a normal /search submit on enter or when JS is unavailable.
document.querySelectorAll('[data-search-form]').forEach((form) => {
  const input = form.querySelector('.crepulo-search__input');
  const results = form.querySelector('[data-search-results]');
  if (!input || !results) return;

  let controller;
  let debounce;

  const esc = (s) => s.replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ));

  const close = () => {
    results.hidden = true;
    input.setAttribute('aria-expanded', 'false');
  };

  const open = () => {
    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  };

  const render = (products, term) => {
    const safe = esc(term);
    let html = '';
    if (products.length) {
      html += '<ul class="crepulo-search__list">';
      products.forEach((p) => {
        const img = (p.featured_image && p.featured_image.url) || p.image || '';
        html += '<li><a class="crepulo-search__item" href="' + p.url + '">'
          + (img
            ? '<img class="crepulo-search__thumb" src="' + img + '" alt="" loading="lazy" width="44" height="44">'
            : '<span class="crepulo-search__thumb"></span>')
          + '<span class="crepulo-search__name">' + esc(p.title) + '</span>'
          + '</a></li>';
      });
      html += '</ul>';
    } else {
      html += '<p class="crepulo-search__empty">No matches for &ldquo;' + safe + '&rdquo; yet.</p>';
    }
    html += '<a class="crepulo-search__all" href="/search?q=' + encodeURIComponent(term)
      + '">Search for &ldquo;' + safe + '&rdquo; &rarr;</a>';
    results.innerHTML = html;
    open();
  };

  const run = (term) => {
    if (controller) controller.abort();
    controller = new AbortController();
    const url = '/search/suggest.json?q=' + encodeURIComponent(term)
      + '&resources[type]=product&resources[limit]=6'
      + '&resources[options][unavailable_products]=last';
    fetch(url, { signal: controller.signal })
      .then((r) => r.json())
      .then((data) => {
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        render(products, term);
      })
      .catch((e) => { if (e.name !== 'AbortError') close(); });
  };

  input.addEventListener('input', () => {
    const term = input.value.trim();
    clearTimeout(debounce);
    if (term.length < 2) { close(); return; }
    debounce = setTimeout(() => run(term), 200);
  });

  input.addEventListener('focus', () => {
    if (input.value.trim().length >= 2 && results.innerHTML) open();
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { close(); input.blur(); }
  });

  document.addEventListener('click', (e) => {
    if (!form.contains(e.target)) close();
  });
});

document.querySelectorAll('[data-product-section]').forEach((productSection) => {
  const variantSelect = productSection.querySelector('.variant-select');
  const primaryImage = productSection.querySelector('[data-pdp-primary-image]');

  if (!variantSelect || !primaryImage) return;

  const showSelectedVariantImage = () => {
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    const mediaUrl = selectedOption?.dataset.mediaUrl;

    if (!mediaUrl) return;

    primaryImage.src = mediaUrl;
    primaryImage.removeAttribute('srcset');
    primaryImage.alt = selectedOption.dataset.mediaAlt || selectedOption.textContent.trim();
  };

  variantSelect.addEventListener('change', showSelectedVariantImage);
  showSelectedVariantImage();
});
